import { render, staticRenderFns } from "./LxDateTimePicker.vue?vue&type=template&id=13a142cb&scoped=true"
import script from "./LxDateTimePicker.vue?vue&type=script&lang=js"
export * from "./LxDateTimePicker.vue?vue&type=script&lang=js"
import style0 from "./LxDateTimePicker.vue?vue&type=style&index=0&id=13a142cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a142cb",
  null
  
)

export default component.exports